var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenSuccessTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 141,
    viewBox: "0 0 127 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11587_101633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7067 25.2111C56.1955 23.0928 57.4399 22.0337 58.7373 21.4115C60.2232 20.7009 61.8494 20.332 63.4965 20.332C65.1436 20.332 66.7698 20.7009 68.2557 21.4115C69.5575 22.0293 70.8019 23.0884 73.2863 25.2111C74.2792 26.0584 74.7734 26.4776 75.303 26.8307C76.5156 27.6435 77.8776 28.2074 79.3098 28.49C79.932 28.6135 80.5807 28.6665 81.878 28.7724C85.1391 29.0284 86.7674 29.1608 88.1266 29.6418C89.679 30.1897 91.0891 31.078 92.2536 32.2418C93.418 33.4055 94.3073 34.8151 94.8561 36.3673C95.3371 37.7309 95.4651 39.3593 95.7254 42.6161C95.8269 43.9136 95.8799 44.5623 96.0034 45.189C96.2859 46.6188 96.8507 47.9824 97.6627 49.1916C98.0157 49.7212 98.4393 50.2154 99.2822 51.2084C101.4 53.6973 102.464 54.9418 103.086 56.2392C103.797 57.7252 104.165 59.3515 104.165 60.9987C104.165 62.6459 103.797 64.2722 103.086 65.7582C102.468 67.0556 101.405 68.3001 99.2822 70.789C98.7052 71.4306 98.1645 72.1039 97.6627 72.8058C96.8502 74.0171 96.2862 75.3776 96.0034 76.8084C95.8799 77.4351 95.8269 78.0838 95.7254 79.3813C95.4651 82.6381 95.3371 84.2709 94.8561 85.6301C94.3073 87.1823 93.418 88.5919 92.2536 89.7556C91.0891 90.9194 89.679 91.8077 88.1266 92.3556C86.7674 92.841 85.1391 92.969 81.878 93.225C80.5807 93.3309 79.9364 93.3838 79.3098 93.5074C77.8776 93.7899 76.5156 94.354 75.303 95.1667C74.6026 95.6687 73.9308 96.2094 73.2907 96.7863C70.8019 98.9046 69.5575 99.9637 68.2601 100.586C66.7742 101.297 65.148 101.665 63.5009 101.665C61.8538 101.665 60.2276 101.297 58.7417 100.586C57.4399 99.9681 56.1955 98.909 53.7111 96.7863C53.0695 96.2094 52.3962 95.6687 51.6944 95.1667C50.4818 94.354 49.1198 93.7899 47.6876 93.5074C46.8374 93.3658 45.98 93.2715 45.1194 93.225C41.8583 92.969 40.23 92.8366 38.8708 92.3556C37.3184 91.8077 35.9083 90.9194 34.7438 89.7556C33.5794 88.5919 32.6901 87.1823 32.1413 85.6301C31.6603 84.2709 31.5323 82.6381 31.272 79.3813C31.2279 78.5191 31.1351 77.6601 30.994 76.8084C30.7109 75.3777 30.1469 74.0172 29.3347 72.8058C28.9817 72.2762 28.5581 71.782 27.7152 70.789C25.5971 68.3001 24.5336 67.0556 23.9114 65.7582C23.2008 64.2722 22.832 62.6459 22.832 60.9987C22.832 59.3515 23.2008 57.7252 23.9114 56.2392C24.5336 54.9418 25.5927 53.6973 27.7152 51.2084C28.5581 50.2154 28.9817 49.7212 29.3347 49.1916C30.1469 47.9802 30.7109 46.6197 30.994 45.189C31.1175 44.5623 31.1705 43.9136 31.272 42.6161C31.5323 39.3593 31.6603 37.7309 32.1413 36.3673C32.6906 34.8147 33.5805 33.4048 34.7458 32.241C35.911 31.0772 37.322 30.1891 38.8752 29.6418C40.2344 29.1608 41.8627 29.0284 45.1238 28.7724C46.4211 28.6665 47.0654 28.6135 47.692 28.49C49.1243 28.2074 50.4862 27.6435 51.6989 26.8307C52.2284 26.4776 52.7182 26.0584 53.7067 25.2111Z",
    fill: "#05AF35",
    stroke: "#05AF35",
    strokeWidth: 12.3075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2734 62.8886L57.8342 70.4497L76.7359 51.5469",
    fill: "#05AF35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2734 62.8886L57.8342 70.4497L76.7359 51.5469",
    stroke: "white",
    strokeWidth: 10.1667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11587_101633",
    x: -13.91,
    y: 0,
    width: 154.82,
    height: 154.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.41
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.20501
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11587_101633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11587_101633",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSuccessTick);
export default __webpack_public_path__ + "static/media/green-success-tick.1b1d10255785ee0270c442c0735bc8de.svg";
export { ForwardRef as ReactComponent };